import React from "react"
import { ColorMode, Styled } from "theme-ui"

export const wrapRootElement = ({ element, props }) => (
  <>
    <ColorMode />
      <Styled.root>{element}</Styled.root>
  </>
)
